import { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useMediaQuery } from "react-responsive";

const testimonials = [
  { name: "Gopu Bharaniram", text: "Exceptional service and a great investment opportunity. The developers truly understand customer needs." },
  { name: "Siva Ramakrishna", text: "One of the finest real estate ventures in Rajahmundry. Transparent dealings and bank loan assistance available." },
  { name: "Ravi Teja", text: "A seamless and hassle-free process. The team guided me well throughout the purchase journey." },
  { name: "Meena Sharma", text: "Highly professional and reliable developers. The entire process was smooth and well-organized." },
  { name: "Arjun Verma", text: "A great location with all modern amenities. The investment feels secure and promising." },
  { name: "Neha Kapoor", text: "Extremely satisfied with the experience. The property and services exceeded my expectations." },
];

function TestimonialSlider() {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const itemsPerRow = isMobile ? 1 : 3;
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + itemsPerRow) % testimonials.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [itemsPerRow]);

  return (
    <div className="container my-5">
      <h2 className="text-center mb-4 fw-bold text-black">Our Testimonials</h2>
      <div className="d-flex justify-content-center gap-3 flex-wrap">
        {testimonials.slice(currentIndex, currentIndex + itemsPerRow).map((testimonial, index) => (
          <div key={index} className="testimonial-card" style={{ width: isMobile ? "100%" : "30%" }}>
            <div className="card p-4 shadow-lg border-0 text-center">
              <h5 className="fw-bold text-dark">{testimonial.name}</h5>
              <p className="text-muted fst-italic">"{testimonial.text}"</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
export default TestimonialSlider;




